import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  orgConfig: null,     // Only one config expected
  authToken: null      // SMART/FHIR access token
};

const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    setOrgConfig: (state, action) => {
      state.orgConfig = action.payload;
    },
    clearOrgConfig: (state) => {
      state.orgConfig = null;
    },
    setAuthToken: (state, action) => {
      state.authToken = action.payload;
    },
    clearAuthToken: (state) => {
      state.authToken = null;
    }
  }
});

export const {
  setOrgConfig,
  clearOrgConfig,
  setAuthToken,
  clearAuthToken
} = configSlice.actions;

export default configSlice.reducer;